<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="24">
        <showButtonPdf :type="4" label="Descargar Dictamen Técnico"/>
      </el-col>
    </el-row>
    <el-form-item
        label="1. Tipo de solicitud"
        prop="cat_acquisition_type_id"
        :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change'] }">
      <el-select
          style="width:100%"
          v-model="requestForm.cat_acquisition_type_id"
          filterable
          :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
          @change="resetArticles(requestForm.cat_acquisition_type_id)"
          placeholder="Seleccionar">
        <el-option
            v-for="(item,key) in filterType(catalogs.catAcquisitionType)"
            :key="key"
            :label="item.name"
            :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item
        label="2. Nombre del bien o servicio a contratar"
        prop="service_name_id"
        :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">
      <el-select
          style="width:100%"
          v-model="requestForm.service_name_id"
          filterable
          clearable
          :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
          placeholder="Se deberá de especificar el nombre completo del servicio o bien a contratar, especificando si se trata de una adquisición, arrendamiento o servicio">
        <el-option
            v-for="(item,key) in catalogs.serviceName.filter(up => up.type_service_id == requestForm.cat_acquisition_type_id)"
            :key="key"
            :label="item.name "
            :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item
        v-if="enableIsOther == true"
        label="Describe otro"
        prop="name"
        :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">
      <el-input
          :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
          v-model="requestForm.name"
          placeholder="Describe otro">
      </el-input>
    </el-form-item>
    <el-form-item
        label="3. Representaciones involucradas"
        prop="office_ids"
        :rules="{ required: false, message: 'Este campo es obligatorio', trigger: ['blur','change'] }">
      <el-select
          style="width:100%"
          @change="filterOfficesIds(requestForm.office_ids)"
          v-model="requestForm.office_ids"
          filterable
          multiple
          :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
          placeholder="Seleccionar">
        <el-option
            v-for="(item,key) in catalogs.catOffice"
            :key="key"
            :label="item.representation_name"
            :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item
        label="4. Objeto de la contratación"
        :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change'] }"
        prop="backgroundOfObjectives">
      <el-tooltip placement="top">
        <div slot="content" style="font-size: 12pt">
          {{ descriptions.backgroundOfObjectives }}
        </div>
        <i style="font-size: 13px" class="fas fa-info"/>
      </el-tooltip>
      <el-button
          type="text"
          style="font-size: 13px"
          v-clipboard:copy="requestForm.backgroundOfObjectives"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
      >
        Copiar <i class="fas fa-copy"/>
      </el-button>
      <el-button
          type="text"
          v-if="infoUser.profile == 1"
          @click="showModalDescription(descriptions.backgroundOfObjectives, 'backgroundOfObjectives')"
          style="font-size: 13px">
        Actualizar sugerencia de redacción<i class="fas fa-align-justify"></i>
      </el-button>
      <editor
          :init='init'
          id="backgroundOfObjectives1"
          v-model="requestForm.backgroundOfObjectives"
          :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
          placeholder="Acerque el cursor al ícono de información para conocer los detalles de captura de este apartado">
      </editor>
    </el-form-item>
    <el-form-item label="5. Objetivos"
                  :rules="{ required: true,
                      message: 'Este campo es obligatorio',
                      trigger: ['blur','change'] }"
                  prop="projects">
      <el-tooltip placement="top">
        <div slot="content" style="font-size: 12pt">
          {{ descriptions.projects }}
        </div>
        <i style="font-size: 13px" class="fas fa-info"/>
      </el-tooltip>
      <el-button
          type="text"
          style="font-size: 13px"
          v-clipboard:copy="requestForm.projects"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
      >
        Copiar <i class="fas fa-copy"/>
      </el-button>
      <el-button
          type="text"
          v-if="infoUser.profile == 1"
          @click="showModalDescription(descriptions.projects, 'projects')"
          style="font-size: 13px">
        Actualizar sugerencia de redacción<i class="fas fa-align-justify"></i>
      </el-button>
      <editor
          :init='init'
          id="objetivos"
          v-model="requestForm.projects"
          :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
          placeholder="Acerque el cursor al ícono de información para conocer los detalles de captura de este apartado">
      </editor>
    </el-form-item>
    <el-form-item
        label="6. Tamaño de la representación (Usuarios/puestos de trabajo, servidores, computadoras, líneas telefónicas, teléfonos/extensiones, etc.)"
        :rules="{ required: true,
                      message: 'Este campo es obligatorio',
                      trigger: ['blur','change'] }"
        prop="size">
      <el-tooltip placement="top">
        <div slot="content" style="font-size: 12pt">
          {{ descriptions.size }}
        </div>
        <i style="font-size: 13px" class="fas fa-info"/>
      </el-tooltip>
      <el-button
          type="text"
          style="font-size: 13px"
          v-clipboard:copy="requestForm.size"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
      >
        Copiar <i class="fas fa-copy"/>
      </el-button>
      <el-button
          type="text"
          v-if="infoUser.profile == 1"
          @click="showModalDescription(descriptions.size, 'size')"
          style="font-size: 13px">
        Actualizar sugerencia de redacción<i class="fas fa-align-justify"></i>
      </el-button>
      <editor
          :init='init'
          id="descriptionSize"
          v-model="requestForm.size"
          :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
          placeholder="Acerque el cursor al ícono de información para conocer los detalles de captura de este apartado">
      </editor>
    </el-form-item>
    <el-form-item label="7. Cantidad de trámites afectados con este proyecto al mes"
                  :rules="{ required: true,
                      message: 'Este campo es obligatorio',
                      trigger: ['blur','change'] }"
                  prop="quantities">
      <el-tooltip placement="top">
        <div slot="content" style="font-size: 12pt">
          {{ descriptions.quantities }}
        </div>
        <i style="font-size: 13px" class="fas fa-info"/>
      </el-tooltip>
      <el-button
          type="text"
          style="font-size: 13px"
          v-clipboard:copy="requestForm.quantities"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
      >
        Copiar <i class="fas fa-copy"/>
      </el-button>
      <el-button
          type="text"
          v-if="infoUser.profile == 1"
          @click="showModalDescription(descriptions.quantities, 'quantities')"
          style="font-size: 13px">
        Actualizar sugerencia de redacción<i class="fas fa-align-justify"></i>
      </el-button>
      <editor
          :init='init'
          id="q"
          v-model="requestForm.quantities"
          :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
          placeholder="Acerque el cursor al ícono de información para conocer los detalles de captura de este apartado">
      </editor>
    </el-form-item>
    <el-form-item label="8. Descripción de la situación actual"
                  :rules="{ required: true,
                      message: 'Este campo es obligatorio',
                      trigger: ['blur','change'] }"
                  prop="analysis">
      <el-tooltip placement="top">
        <div slot="content" style="font-size: 12pt">
          {{ descriptions.analysis }}
        </div>
        <i style="font-size: 13px" class="fas fa-info"/>
      </el-tooltip>
      <el-button
          type="text"
          style="font-size: 13px"
          v-clipboard:copy="requestForm.analysis"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
      >
        Copiar <i class="fas fa-copy"/>
      </el-button>
      <el-button
          type="text"
          v-if="infoUser.profile == 1"
          @click="showModalDescription(descriptions.analysis, 'analysis')"
          style="font-size: 13px">
        Actualizar sugerencia de redacción<i class="fas fa-align-justify"></i>
      </el-button>
      <editor
          :init='init'
          id="analysis"
          v-model="requestForm.analysis"
          :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
          placeholder="Acerque el cursor al ícono de información para conocer los detalles de captura de este apartado">
      </editor>
    </el-form-item>
    <el-form-item label="8.1. Contrataciones anteriores"
                  :rules="{ required: true,
                      message: 'Este campo es obligatorio',
                      trigger: ['blur','change'] }"
                  prop="beforeContract">
      <el-tooltip placement="top">
        <div slot="content" style="font-size: 12pt">
          {{ descriptions.beforeContract }}
        </div>
        <i style="font-size: 13px" class="fas fa-info"/>
      </el-tooltip>
      <el-button
          type="text"
          style="font-size: 13px"
          v-clipboard:copy="requestForm.beforeContract"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
      >
        Copiar <i class="fas fa-copy"/>
      </el-button>
      <el-button
          type="text"
          v-if="infoUser.profile == 1"
          @click="showModalDescription(descriptions.beforeContract, 'beforeContract')"
          style="font-size: 13px">
        Actualizar sugerencia de redacción<i class="fas fa-align-justify"></i>
      </el-button>
      <editor
          :init='init'
          id="beforeContract"
          v-model="requestForm.beforeContract"
          :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
          placeholder="Acerque el cursor al ícono de información para conocer los detalles de captura de este apartado">
      </editor>
    </el-form-item>
    <el-form-item label="8.2. Problemática a resolver"
                  :rules="{ required: true,
                      message: 'Este campo es obligatorio',
                      trigger: ['blur','change'] }"
                  prop="problemToSolve">
      <el-tooltip placement="top">
        <div slot="content" style="font-size: 12pt">
          {{ descriptions.problemToSolve }}
        </div>
        <i style="font-size: 13px" class="fas fa-info"/>
      </el-tooltip>
      <el-button
          type="text"
          style="font-size: 13px"
          v-clipboard:copy="requestForm.problemToSolve"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
      >
        Copiar <i class="fas fa-copy"/>
      </el-button>
      <el-button
          type="text"
          v-if="infoUser.profile == 1"
          @click="showModalDescription(descriptions.problemToSolve, 'problemToSolve')"
          style="font-size: 13px">
        Actualizar sugerencia de redacción<i class="fas fa-align-justify"></i>
      </el-button>
      <editor
          :init='init'
          id="problemToSolve"
          v-model="requestForm.problemToSolve"
          :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
          placeholder="Acerque el cursor al ícono de información para conocer los detalles de captura de este apartado">
      </editor>
    </el-form-item>
    <el-form-item label="9. Características y especificaciones técnicas"
                  :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change'] }"
                  prop="articles">
      <Articles :disabledAdd="true" :disbaledField:="false"/>

    </el-form-item>
    <br>
    <el-row :gutter="20">
      <el-col :span="24">
        <showButtonPdf :type="4" label="Descargar Dictamen Técnico"/>
      </el-col>

    </el-row>
    <br>
    <Docs :onlyRead="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
          :sectionId="10">
      <div slot="main">
        Suba su documento firmado "Dictamen Técnico Informático Regional"
      </div>
    </Docs>
    <el-dialog
        :fullscreen="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        title="Redacción sugerida"
        :visible.sync="modalDescription">
      <el-form
          @submit.native.prevent>
        <el-row>
          <el-col>
            <el-input
                type="textarea"
                :rows="10"
                v-model="modelDescription.text"/>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
            icon="fas fa-save"
            @click="saveDescription()">
          Guardar
        </el-button>
        <el-button
            icon="fas fa-times"
            @click="modelDescription.text = ''; modalDescription = false">
          Cerrar
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {mapState, mapGetters, mapActions, mapMutations} from "vuex";
import showButtonPdf from '@/components/views/acquisition/partials/showButtonPdf';
import Articles from '@/components/views/acquisition/partials/Articles';
import Docs from '@/components/views/acquisition/partials/Docs'
import {Notification} from 'element-ui';

export default {
  props: {
    showField: {

      type: Boolean
    }
  },
  components: {
    showButtonPdf, Articles, Docs
  },
  computed: {
    infoUser() {
      return this.$store.state.user
    },
    ...mapGetters("form", {
      requestForm: "requestForm",
      catalogs: "catalogs",
      onlyRead: "onlyRead",
      optionEditor: "optionEditor",
      descriptions: "descriptionsAreas"
    }),
  },
  data() {
    return {
      enableIsOther: false,
      modelDescription: {},
      modalDescription: false,
      init: {
        language_url: '/tinymce/langs/es_419.js',
        language: 'es_419',
        skin_url: 'tinymce/skins/ui/oxide',
        // skin_url: 'tinymce/skins/ui/oxide-dark', // color oscuro
        height: 350,
        // inline: true,
        menubar: false,
        toolbar: 'undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | ' +
            'bullist numlist outdent indent | link image | print preview media fullscreen',
        content_style: 'body { font-family:Montserrat; font-size:12px }'
      },
    }
  },

  created() {
    this.filterProductService(this.catalogs.serviceName, this.requestForm.cat_acquisition_type_id)
  },


  methods: {
    ...mapMutations('form', {
      resetArticles: "resetArticles",
      addLevel: "addLevel",
      removeLevel: "removeLevel",
      addSupport: "addSupport",
      removeSupport: "removeSupport",
      addDeliverable: "addDeliverable",
      removeDeliverable: "removeDeliverable",
      addCalendar: "addCalendar",
      removeCalendar: "removeCalendar",
    }),
    ...mapActions('form', {
      fetchDescriptions: "fetchDescriptions"
    }),
    filterProductService(data, type) {
      if (!data && !type) return [];
      return data = data.filter((item) => item.type_service_id == type);
    },
    filterType(data) {
      if (!data) return [];
      if (data && !this.showField) {
        return data /*= data.filter(up => up.id >= 5)*/;
      } else {

      }
    },
    filterOfficesIds(offices) {
      let _array = [];
      let _keys = [];
      let _ids = [];
      if (offices && offices.length > 0 && this.requestForm.articles.length > 0) {
        _keys = Object.keys(this.requestForm.articles);
        _.forEach(_keys, element => {
          this.requestForm.articles[element].office_ids = _.intersection(offices, this.requestForm.articles[element].office_ids)
        });
      } else if (offices && offices.length == 0 && this.requestForm.articles.length > 0) {
        this.requestForm.articles.forEach(item => {
          item.office_ids = [];
        })
      }
    },
    async onCopy(e) {
      try {
        await this.$copyText(this.stripHtml(e.text)).then(async function (ee) {
          Notification.success('Se copió el texto correctamente.')
        }, function (e) {
          console.log(e)
        })
      } catch (e) {
        console.log("copy clipboard ", e)
      }
    },
    onError: function (e) {
      alert('Failed to copy the text to the clipboard')
      console.log(e);
    },
    stripHtml(html) {
      let tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || "";
    },
    showModalDescription(text, model) {
      let _object = {
        text: text,
        model: model
      }
      this.modelDescription = Object.assign({}, _object);
      this.modalDescription = true;
    },
    saveDescription() {
      axios.post('/api/acquisitions/s-description', {
        description: this.modelDescription
      }).then(response => {
        if (response.data.success) {
          Notification.success(response.data.message);
          this.modalDescription = false;
          this.fetchDescriptions();
        } else {
          Notification.error(response.data.message)
        }
      }).catch(e => {
        console.log("error ", e);
        Notification.error('No se pudo procesar su solicitud.')
      })
    },
    removeAccents(str) {
      let accents = 'ÀÁÂÃÄÅàáâãäåßÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
      let accentsOut = "AAAAAAaaaaaaBOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz";
      str = str.split('');
      str.forEach((letter, index) => {
        let i = accents.indexOf(letter);
        if (i != -1) {
          str[index] = accentsOut[i];
        }
      })
      return str.join('');
    },

    checkText(text) {
      console.log(text?.replace(' ', '<br>'))
      return text?.replace(' ', '</br>')
    }


  }
}
</script>

<style scoped>

</style>